import { AppUser } from 'Src/views/App/App';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import axios from 'Src/helpers/api/axiosInstance';

export function getAllAwardEventVideos(user: AppUser, awardEventId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        limit: DEFAULT_LIMIT,
        skip: DEFAULT_SKIP
      }
    }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/videos`, config)
    .then(response => {
      return response.data;
    });
}

export function addAwardEventVideo(user: AppUser, awardEventId: string, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/videos`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deleteAwardEventVideo(user: AppUser, awardEventId: string, videoId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .delete(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/videos/${videoId}`, config)
    .then(response => {
      return response.data;
    });
}

export function updateAwardEventVideo(user: AppUser, awardEventId: string, videoId: string, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/videos/${videoId}`, data, config)
    .then(response => {
      return response.data;
    });
}
